import React from 'react'
import PropTypes from 'prop-types'
import { Button, Link } from './style'

const MuiButton = props => {
  let toUrl
  let object = {}

  const _delete = () => {
    const keys = Object.keys(props)
    keys.map(k => {
      if (k !== 'to') object[k] = props[k]
      return k
    })
  }

  if (props?.to) {
    toUrl = props.to; _delete()
  } else {
    object = props
  }

  return (
    <>
      {toUrl ? <Link to={toUrl}><Button {...object} /></Link> : <Button {...object} />}
    </>
  )
}

MuiButton.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  to: PropTypes.string,
  value: PropTypes.string
}

export default MuiButton
